import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IDashboardInstanceSlice } from '../slices/dashboards/dashboardInstance';
import { selectorArg1 } from '../utils/selectors';
import { byTypeName, GraphQLID } from '../../utils/types';

const sliceSelector = (rootState: RootState) => rootState.dashboardInstance;

const dashboardSelector = createSelector(
  sliceSelector,
  ({ dashboard }) => dashboard,
);

export const dashboardPropSelector = <
  T extends keyof IDashboardInstanceSlice,
>() =>
  createSelector(
    sliceSelector,
    selectorArg1<T>(),
    (slice, propKey) => slice[propKey],
  );

export const dashboardSelectUniqueSchemas = createSelector(
  dashboardSelector,
  (dashboard): Array<GraphQLID> =>
    Object.keys(
      dashboard?.rows
        ?.flatMap((r) =>
          r.columns
            .filter(byTypeName('DashboardAnalysisColumn'))
            .map(({ analysis: a }) => a.schema.id),
        )
        .reduce<Record<GraphQLID, boolean>>((acc, schema) => {
          acc[schema] = true;
          return acc;
        }, {}) ?? {},
    ),
);
